import { useGetNotificationsCounterQuery } from 'app/services/notifications';
import { createContext, ReactNode, useContext, useMemo } from 'react';
import { useAuth } from 'utils/AuthProvider';
import {
  oneMinute,
  oneSecond,
} from '../conversations/Hooks/useElapsedTimeFromNow';

const NotificationsCounterContext = createContext<
  | {
      unread_messages_count: number;
      unread_notifications_count: number;
    }
  | undefined
>({} as any);

export function useNotificationsCounter() {
  return useContext(NotificationsCounterContext);
}

export default function NotificationsCounterProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { user } = useAuth();
  const { data } = useGetNotificationsCounterQuery(undefined, {
    pollingInterval: 20 * oneSecond,
    skip: !user,
  });

  const memo = useMemo(
    () => data,
    [data?.unread_messages_count, data?.unread_notifications_count],
  );
  return (
    <NotificationsCounterContext.Provider value={memo}>
      {children}
    </NotificationsCounterContext.Provider>
  );
}
